import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Row, Form, Spinner } from 'react-bootstrap'
import TableComponentPage4 from '../Table/GroupTable';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useNavigate } from 'react-router-dom';

function Campaigns() {

  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: "Campaign ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span >
            {value === 1 ? "Active" : "Inactive"}
          </span>
        ),
      },
      {
        Header: "Link",
        accessor: "link",
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
    ],
    []
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1)
  const [CampaignPages, setCampaignPages] = useState(1);
  const [loadingCampaign, setLoadingCampaign] = useState(false)
  const [campaigns, setCampaigns] = useState([])
  const [ltLang, setLtLang] = useState([])
  const [campaignFilter, setCampaignFilter] = useState({
    filters: {
      campaignid: "",
      language: "",
      campaignname: ""
    }
  })
  const [resetTable, setResetTable] = useState(false);
  const [campaignloadingStatus, setCampaignLoadingStatus] = useState(false)
  const [CampaignStatus, setCampaignStatus] = useState({
    status: 0
  })
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const getCampaigns = async () => {
    setLoadingCampaign(true)
    const response = await axios.post(window.__CFG.API + "marketing/ListCampaigns?page=" + currentPage, campaignFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingCampaign(false)
    if (response.data.Error == null) {
      setCampaigns(response.data.Result.Data);
      var pages = response.data.Pages
      setCampaignPages(response.data.Result.Pages)
    }
    else {
      setCampaigns([]);
    }
  }
  useEffect(() => { getCampaigns() }, [currentPage, CampaignPages])

  const handleCampaignStatus = async () => {
    if (selectedRows.length > 0) {
      setCampaignLoadingStatus(true)
      selectedRows.forEach(async sr => {
        const response = await axios.post(window.__CFG.API + "marketing/ChangeCampaignStatus/" + sr.id, CampaignStatus, {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("raff-token")
          }
        })
        if (response.data.Error == null) {
          setCampaignLoadingStatus(false)
          toast.success("Saved Sucessufully", {
            duration: 4000
          });
          getCampaigns()
          setSelectedRows([]);
          setResetTable(!resetTable);
        }
        else {
          toast.error(response.data.Error, {
            duration: 4000
          })
        }
      })
    }
    else {
      toast.error("Please select a row", {
        duration: 4000
      })
    }
  }
  const getListLanguages = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtLang(response.data.Result)
    }
  }
  useEffect(() => { getListLanguages() }, [])
  const handleSelectedRowsChange = (selectedRows) => {
    setSelectedRows(selectedRows);
  }
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsStatus = [{ label: "Active", value: 1 }, { label: "Inactive", value: 0 }]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

  return (
    <>
      <Container>
        <Row>
          <Col>

            <h4 className="text-start mt-5">List Campaigns</h4>

            <Row className="justify-content-between  mt-5  me-auto w-100">
              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Campaign id </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={campaignFilter.filters.campaignid} onChange={e => { setCampaignFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, campaignid: e.target.value } })) }} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={5} className="campaign-btn">
                <Button onClick={() => navigate("/affiliate/marketing/campaign-create")} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp create-compaign-btn">
                  Create new Campaign +
                </Button>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2  me-auto w-100">
              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Campaign name </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={campaignFilter.filters.campaignname} onChange={e => { setCampaignFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, campaignname: e.target.value } })) }} />
                  </div>
                </div>
              </Col>

            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>status </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsStatus} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Currency </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsCurrency} value={selectedCurrencyValue} />

                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>language </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={ltLang} onChange={e => { setCampaignFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, language: e.value } })) }} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100" >
              <Col lg={6} md={4} sm={5} className=" pt-2">
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                  </div>
                  <div className="form-cre-grp-fl-wp-in  md-se-btn">
                    <Button disabled={loadingCampaign} onClick={getCampaigns} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp btn-search-compaigns">
                      {loadingCampaign ? (<> <Spinner size="sm"></Spinner></>) : (<>
                        Search
                      </>)}
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            <div
              style={{
                borderBottom: "1px dashed black",
                marginTop: "30px",
                width: "100%",
              }}
            ></div>
            <Row className="mt-3 mb-4">
              <div className="aff-dash-summary-table">
                <TableComponentPage4 key={resetTable} columns={columns} data={campaigns} Pages={CampaignPages} currentPage={currentPage} loading={loadingCampaign} onSelectedRowsChange={handleSelectedRowsChange} onPageChange={handlePageChange} linkColumn="id" linkUrl="/affiliate/marketing/campaign/details?id=" />
              </div>
            </Row>
            <div style={{ display: "flex", alignItems: "center", maxWidth: 500 }}>
              <div className="form-cre-grp-fl-wp" style={{ flex: 1 }}>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={optionsStatus} onChange={(e) => { setCampaignStatus({ ...CampaignStatus, status: e.value }) }} />
                </div>
              </div>
              <div style={{ flex: 1 }} className='apply-btn'>
                <Button disabled={campaignloadingStatus} onClick={handleCampaignStatus} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  {campaignloadingStatus ? (<> <Spinner size="sm"></Spinner></>) : (<>
                    Apply
                  </>)}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Campaigns